import { render, staticRenderFns } from "./product-will-receive.vue?vue&type=template&id=a8d1bee4&scoped=true&"
import script from "./product-will-receive.vue?vue&type=script&lang=js&"
export * from "./product-will-receive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d1bee4",
  null
  
)

export default component.exports